import { fetchDomainList } from '@/services/domains.service'
import { filterTrackingDomains } from './trackingDomainFilters'

export function fetchTrackingDomains () {
  return fetchDomainList('/domain').then(filterTrackingDomains)
}
